import React, {ForwardedRef, forwardRef} from 'react';
import classnames from 'classnames/bind';
import Printable from '../Product';

import {IRecommendations, IVehicle} from '../../../interface';

import style from './index.module.scss';

const cx = classnames.bind(style);

export interface IProps {
  data: IRecommendations[];
  vehicle: IVehicle | undefined;
}

/* eslint-disable react/display-name */
const ComponentPrintable = forwardRef(
  (props: IProps, ref: ForwardedRef<HTMLDivElement>) => {
    const {data, vehicle} = props;

    return (
      <div data-testid="component-printable" ref={ref} className={cx('wrapper')}>
        {data
          .filter(
            (recommendation: IRecommendations) =>
              'recommendedProduct' in recommendation &&
              'description' in recommendation.recommendedProduct,
          )
          .map((recommendation: IRecommendations, index) => {
            return (
              <div key={index}>
                <Printable
                  data={recommendation.recommendedProduct}
                  vehicle={vehicle}
                  componentName={recommendation.name}
                  volumes={recommendation.vehicleComponentVolumes}
                  notes={recommendation.notes}
                />

                {recommendation.alternateProducts.map((product, idx) => {
                  return (
                    <div key={idx}>
                      <Printable
                        key={product.id}
                        title='Alternative Recommendation'
                        data={product}
                        vehicle={vehicle}
                        componentName={recommendation.name}
                        volumes={recommendation.vehicleComponentVolumes}
                        notes={recommendation.notes}
                      />
                    </div>
                  );
                })}
              </div>
            );
          })}
      </div>
    );
  },
);

export default ComponentPrintable;
